import { Popover } from 'antd';
import { useTranslation } from 'react-i18next';

import { JsonTrigger, PopoverContent } from './JsonField.style';
import { parseJsonObjectString, renderDenseJson } from './jsonField.utils';

type Props = {
  keyValue: string;
  value: string;
};

export const JsonFieldValue = ({ keyValue, value }: Props) => {
  const { t } = useTranslation();
  const parsed = parseJsonObjectString(value);

  if (!parsed) {
    return <div key={keyValue}>{value}</div>;
  }

  return (
    <Popover
      trigger={['hover', 'focus']}
      arrow={{ pointAtCenter: true }}
      placement="rightTop"
      content={<PopoverContent>{renderDenseJson(parsed)}</PopoverContent>}
    >
      <JsonTrigger type="button">{t('components.json', 'JSON')}</JsonTrigger>
    </Popover>
  );
};
